import { graphql } from 'gatsby';
import { PostLayout } from '../../components/entities/post-layout';
import { createGatsbyPageComponent } from '@shapeable/ui';

export default createGatsbyPageComponent('Post', { layout: PostLayout });

export const QUERY = graphql`
query PostQuery($id: ID!) {
  platform { post(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel } 
    name name_fr name_de 
    title title_fr title_de
    pretitle pretitle_fr pretitle_de
    subtitle subtitle_fr subtitle_de
    published
    edited
    content { plain text }
    content_fr { plain text }
    content_de { plain text }
    openGraph { title description { plain } image { thumbnails { full { url url2x } } } }
    intro { plain text }
    intro_fr { plain text }
    intro_de { plain text }
    outro { text }
    outro_fr { text }
    outro_de { text }
    files {
      id
      name
      label
      slug
      file {
        id
        url
      }
    }
    videos {
      id name url
      thumbnail { id url url2x }
    }
    imageAssets {
      id name image { id url url2x }
    }
    organisations {
      id name slug path
      logo { id url url2x }
    }
    authors {
      id name slug path
      organisation { id name }
      linkedin
      photo { id url url2x }
      positions {
        id
        primary
        positions {
          id 
          name 
          name_fr
          name_de
        }
        organisation { id name }
      }
    }
    people {
      id name slug path
      organisation { id name }
      linkedin
      photo { id url url2x }
      positions {
        id
        primary
        positions {
          id 
          name 
          name_fr
          name_de
        }
        organisation { id name }
      }
    }
    embeds {
      citations {
        slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
      }
      pages {
        id name slug path
        openGraph {
          title description { plain }
          image { url url2x }
        }
      }
      people {
        id name slug path
        organisation { id name }
        position
        photo { id url }
      }
      imageAssets {
        id
        slug
        image {
          id url url2x width height
        }
      }
    }
    banners {
      id name slug title description { text } alternateText
      image { 
        id url url2x width height
      }
    }
  } }
}
`;
